import PortalCaseLawDocumentDetailsPresenter, {
  IPortalCaseLawDocumentDetailsPresenter
} from "../../presenter/PortalCaseLawDocumentDetailsPresenter";
import GetAllCaseLawDocumentAttachmentsInteractor from "./GetAllCaseLawDocumentAttachmentsInteractor";
import GetAllCaseLawDocumentAttachmentTypesInteractor from "./GetAllCaseLawDocumentAttachmentTypesInteractor";
import GetCaseLawDocumentTypesInteractor from "./GetCaseLawDocumentTypesInteractor";
import GetAllOrganisationsInteractor from "../GetAllOrganisationsInteractor";
import GetCaseLawDocumentIndexesInteractor from "./GetCaseLawDocumentIndexesInteractor";
import GetInvalidatedCaseLawDocumentsInteractor from "./GetInvalidatedCaseLawDocumentsInteractor";
import FindCaseLawDocumentInteractor from "./FindCaseLawDocumentInteractor";
import { ContentTypes } from "../../common/Constants";
import Application from "../../../Application";
import GetGenericCodebookInteractor from "../../../codebooks/interactor/GetGenericCodebookInteractor";
import { TCaseLawDocumentPresentationModel } from "../../../caseLawDocuments/presenter/model/CaseLawDocumentPresentationModel";

export default class ShowPortalCaseLawDocumentDetailsInteractor {
  private application: Application;
  private output?: IPortalCaseLawDocumentDetailsPresenter;
  private findCaseLawDocumentInteractor: FindCaseLawDocumentInteractor;
  private getCaseLawDocumentTypesInteractor: GetCaseLawDocumentTypesInteractor;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;
  private getCaseLawDocumentIndexesInteractor: GetCaseLawDocumentIndexesInteractor;
  private getAllCaseLawDocumentAttachmentTypesInteractor: GetAllCaseLawDocumentAttachmentTypesInteractor;
  private getAllCaseLawDocumentAttachmentsInteractor: GetAllCaseLawDocumentAttachmentsInteractor;
  private getGenericCodebookInteractor: GetGenericCodebookInteractor;
  private getInvalidatedCaseLawDocumentsInteractor: GetInvalidatedCaseLawDocumentsInteractor;
  constructor({
    application,
    findCaseLawDocument,
    getCaseLawDocumentTypes,
    getAllOrganisations,
    getCaseLawDocumentIndexes,
    getAllCaseLawDocumentAttachmentTypes,
    getGenericCodebook,
    getAllCaseLawDocumentAttachments,
    getInvalidatedCaseLawDocuments
  }: any) {
    this.application = application;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getCaseLawDocumentTypesInteractor = getCaseLawDocumentTypes;
    this.findCaseLawDocumentInteractor = findCaseLawDocument;
    this.getCaseLawDocumentIndexesInteractor = getCaseLawDocumentIndexes;
    this.getAllCaseLawDocumentAttachmentTypesInteractor =
      getAllCaseLawDocumentAttachmentTypes;
    this.getAllCaseLawDocumentAttachmentsInteractor =
      getAllCaseLawDocumentAttachments;
    this.getGenericCodebookInteractor = getGenericCodebook;
    this.getInvalidatedCaseLawDocumentsInteractor =
      getInvalidatedCaseLawDocuments;
  }
  private async getContentTypes() {
    return this.getGenericCodebookInteractor.execute(
      ContentTypes.ATTACHMENT_CONTENT_TYPE,
      false
    );
  }
  private async getAttachmentTypes(id) {
    return this.getAllCaseLawDocumentAttachmentTypesInteractor.execute(id);
  }
  private async getInvalidatedCaseLawDocuments(id) {
    return this.getInvalidatedCaseLawDocumentsInteractor.execute(id);
  }
  private async getCaseLawDocumentTypes() {
    return this.getCaseLawDocumentTypesInteractor.execute();
  }
  private async getAllOrganisations() {
    return this.getAllOrganisationsInteractor.execute();
  }

  private async getReferenceLists(id: number) {
    return Promise.all([
      this.getCaseLawDocumentTypes(),
      this.getAllOrganisations(),
      this.getAttachmentTypes(id),
      this.getContentTypes(),
      this.getInvalidatedCaseLawDocuments(id)
    ]);
  }

  execute(id: number) {
    this.output = PortalCaseLawDocumentDetailsPresenter({
      application: this.application,
      initialState: {
        caseLawDocument: {} as TCaseLawDocumentPresentationModel,
        organisations: [],
        caseLawDocumentTypes: [],
        caseLawDocumentIndexes: [],
        attachmentTypes: [],
        attachmentContentTypes: [],
        caseLawDocumentAttachments: [],
        uploadedFile: undefined,
        indexHierarchyList: [],
        invalidatedCaseLawDocuments: []
      }
    });
    this.getReferenceLists(id)
      .then(
        ([
          caseLawDocumentTypes,
          organisations,
          attachmentTypes,
          attachmentContentTypes,
          invalidatedCaseLawDocuments
        ]) =>
          this.output?.loadReferenceValues(
            caseLawDocumentTypes,
            organisations,
            attachmentTypes,
            attachmentContentTypes,
            invalidatedCaseLawDocuments
          )
      )
      .then(() => this.findCaseLawDocumentInteractor.execute(id))
      .then(this.output.loadCaseLawDocument)
      .then(() => this.getAllCaseLawDocumentAttachmentsInteractor.execute(id))
      .then(this.output.loadAttachments)
      .then(() => this.getCaseLawDocumentIndexesInteractor.execute(id))
      .then(this.output.loadCaseLawDocumentIndexes);
    return this.output;
  }
}
